import tubaImg from "../Assets/Projects/Tuba.png";
import batchBrainImg from "../Assets/Projects/BatchBrain.png";
import accImg from "../Assets/Projects/ACC.png";
import findMyFaheemImg from "../Assets/Projects/FindMyFaheem.png";
import linkMyteImg from "../Assets/Projects/LinkMyte.png";
import bcryptyImg from "../Assets/Projects/BCrypty.png";
import sohobyInternalImg from "../Assets/Projects/SohobyInternal.png";

export const personalInfo = {
  name: "Rayyan Waseem",
  title: "Full Stack & React Native Developer",
  status: "Available for Roles & Freelance Projects",
  location: "Lahore, Punjab, Pakistan",
  email: "rayyanwaseem.live@gmail.com",
  bio: "Results-driven Full Stack & React Native Developer with 3+ years of experience in building high-performance mobile applications and scalable backend architectures. Proven track record of shipping 5+ live applications across the Apple App Store and Google Play Store for international clients in Saudi Arabia and global markets.",
  socials: {
    github: "https://github.com/SkullCrawler",
    linkedin: "https://www.linkedin.com/in/rayyanwaseem/",
    twitter: "https://twitter.com/MRayyanWaseem",
    instagram: "https://www.instagram.com/developerrayyan",
  },
  metrics: [
    { label: "Live Store Apps", value: "5+", highlight: "App Store & Play Store" },
    { label: "Development Experience", value: "3+ yrs", highlight: "Full Stack & React Native" },
    { label: "BS Computer Science", value: "3.42", highlight: "GPA • NFC IET Multan" },
    { label: "Operational Cost Reduction", value: "50%", highlight: "Through System Optimization" },
  ],
};

export const ceoEndorsement = {
  name: "Ahmad Mushtaq",
  role: "CEO, Sohoby IT Solutions",
  location: "Jeddah, Saudi Arabia",
  email: "ahmad@ibtdara.com",
  phone: "+966 59 952 9572",
  text: "Rayyan has been an outstanding React Native developer on our team at Sohoby IT Solutions. He independently delivered and maintained complex client applications like Tuba, ACC App, and Find My Faheem. His technical ability to optimize multi-threaded mobile workflows, integrate native APIs, and publish flawlessly to the Apple App Store and Google Play Store was critical to our success in the Saudi market.",
};

export const projects = [
  {
    id: "tuba",
    title: "Tuba (طوبة)",
    category: "mobile",
    categoryLabel: "Real Estate Tech / Mobile",
    platform: "iOS & Android (Live)",
    badge: "App Store & Play Store",
    subtitle: "Premier Real Estate Discovery & Property Marketplace for Saudi Arabia",
    shortDesc: "A flagship mobile real estate application for a prominent Saudi client featuring interactive map exploration, verified listings, and multi-threaded search optimization.",
    longDesc: "Tuba (طوبة) is a high-performance cross-platform mobile real estate application designed for the Saudi Arabian property market. Architected with React Native and TypeScript, the app features multi-threaded background processing that improved performance by 25%, interactive Google Maps with custom clustering for thousands of listings, full Arabic RTL localization, and instant real-time inquiry messaging.",
    tags: ["React Native", "TypeScript", "Google Maps API", "RTL Localization", "Redux Toolkit", "REST APIs", "iOS", "Android"],
    color: "#AD17A6",
    gradient: "linear-gradient(135deg, rgba(173,23,166,0.2) 0%, rgba(67,56,202,0.3) 100%)",
    image: tubaImg,
    links: {
      appStore: "https://apps.apple.com/us/app/tuba-%D8%B7%D9%88%D8%A8%D8%A9/id6745753208",
      playStore: "https://play.google.com/store/apps/details?id=com.tuba",
    },
    highlights: [
      "Optimized property search and filter workflows utilizing multi-threaded architectures, improving app responsiveness by 25%.",
      "Architected interactive property map interfaces with custom geospatial markers and location geocoding.",
      "Delivered complete RTL (Right-to-Left) Arabic language localization for seamless Saudi user experience.",
      "Shipped and maintained production builds on both Apple App Store and Google Play Store.",
    ],
    mockupType: "phone",
    client: "Saudi Client / Sohoby IT Solutions & Tuba Real Estate",
  },
  {
    id: "batchbrain",
    title: "BatchBrain",
    category: "mobile",
    categoryLabel: "AI Education Tech / Hybrid",
    platform: "iOS & Android (Live)",
    badge: "AI Native App",
    subtitle: "AI-Powered Learning Companion & Adaptive Study Assistant",
    shortDesc: "Engineered and published the native hybrid React Native & Expo mobile application on the Apple App Store and Google Play Store.",
    longDesc: "BatchBrain is an AI learning companion providing instant explanations, exam prep, and concept breakdowns. Engineered as a high-performance native hybrid WebView shell in React Native 0.81.5 + Expo SDK 54 wrapping a responsive Django platform. Implemented native OAuth authentication (Google & Apple Sign-In), session validation via expo-secure-store, Firebase Cloud Messaging (FCM) background/foreground push notifications, custom Expo config plugins for camera/mic permissions, and EAS build pipelines for store distribution.",
    tags: ["React Native 0.81.5", "Expo SDK 54", "Google & Apple OAuth", "Firebase FCM", "expo-secure-store", "Native Bridge", "EAS Build"],
    color: "#3b82f6",
    gradient: "linear-gradient(135deg, rgba(59,130,246,0.2) 0%, rgba(29,78,216,0.3) 100%)",
    image: batchBrainImg,
    links: {
      appStore: "https://apps.apple.com/pk/app/batchbrain/id6768643078",
      playStore: "https://play.google.com/store/apps/details?id=com.batchbrain.batchbrain",
      web: "https://batchbrain.com",
    },
    highlights: [
      "Engineered React Native 0.81.5 + Expo SDK 54 hybrid shell with two-way JS communication bridge.",
      "Integrated native Google OAuth and Apple Sign-In with persistent session cookie sync via expo-secure-store.",
      "Configured Firebase Cloud Messaging for foreground and background push notification delivery.",
      "Successfully deployed and passed store compliance on both Apple App Store and Google Play Store.",
    ],
    mockupType: "phone",
    client: "BatchBrain Platform",
  },
  {
    id: "acc",
    title: "ACC App",
    category: "mobile",
    categoryLabel: "PropTech & Facilities / Mobile",
    platform: "iOS (Live App)",
    badge: "Apple App Store Live",
    subtitle: "Comprehensive Tenant & Plaza Management Platform for Saudi Arabia",
    shortDesc: "All-in-one tenant and facility management application handling gym bookings, meeting room reservations, valet parking, and maintenance tickets.",
    longDesc: "ACC App is a comprehensive enterprise tenant management system engineered for residential and commercial plazas in Saudi Arabia. Built with React Native, it enables tenants to book amenities, request valet parking, reserve conference rooms, report facility maintenance with image uploads, and track service statuses in real time.",
    tags: ["React Native", "TypeScript", "Facility Management", "Booking Engine", "Push Notifications", "REST APIs", "iOS"],
    color: "#10b981",
    gradient: "linear-gradient(135deg, rgba(16,185,129,0.2) 0%, rgba(5,150,105,0.3) 100%)",
    image: accImg,
    links: {
      appStore: "https://apps.apple.com/pk/app/a-c-c-app/id6740903560",
    },
    highlights: [
      "Engineered unified booking engine for meeting rooms, fitness centers, and valet parking.",
      "Integrated real-time maintenance ticketing with camera photo attachment and push notifications.",
      "Implemented role-based access control for tenants, facility managers, and building administrators.",
      "Published and maintained live on the Apple App Store.",
    ],
    mockupType: "phone",
    client: "Saudi Arabia Facilities Client / Sohoby IT Solutions",
  },
  {
    id: "find-my-faheem",
    title: "Find My Faheem",
    category: "mobile",
    categoryLabel: "EdTech & Collaboration / Mobile",
    platform: "iOS (Live App)",
    badge: "Apple App Store Live",
    subtitle: "On-Demand Tutor Booking & Student-Teacher Collaboration Platform",
    shortDesc: "A mobile marketplace connecting students with verified subject-matter tutors featuring scheduling, interactive search, and session booking.",
    longDesc: "Find My Faheem empowers students across the Middle East to discover, evaluate, and book certified tutors across academic and professional disciplines. Features real-time schedule slot booking, subject filters, verified tutor profiles, in-app reviews, and secure checkout flows.",
    tags: ["React Native", "TypeScript", "EdTech", "Calendar Booking", "In-App Reviews", "Redux", "iOS"],
    color: "#ec4899",
    gradient: "linear-gradient(135deg, rgba(236,72,153,0.2) 0%, rgba(190,24,93,0.3) 100%)",
    image: findMyFaheemImg,
    links: {
      appStore: "https://apps.apple.com/pk/app/find-my-faheem/id6472804332",
    },
    highlights: [
      "Built dynamic tutor search filtering by subject, hourly rates, ratings, and location.",
      "Engineered calendar booking system preventing overlapping reservation slots.",
      "Integrated secure payment and booking confirmation pipelines.",
      "Published on Apple App Store with consistent 60fps animations.",
    ],
    mockupType: "phone",
    client: "Faheem EdTech / Sohoby IT Solutions",
  },
  {
    id: "linkmyte",
    title: "LinkMyte",
    category: "mobile",
    categoryLabel: "Networking Tech / Mobile",
    platform: "iOS (Live App)",
    badge: "Apple App Store Live",
    subtitle: "QR-Based Digital Business Card & Contact Networking Solution",
    shortDesc: "A modern digital networking mobile app allowing professionals to create, share, and scan digital business cards via dynamic QR codes.",
    longDesc: "LinkMyte revolutionizes contact exchange at corporate events and conferences. Users design custom digital business profiles with portfolio links, social handles, and contact cards, sharing them instantly via high-resolution dynamic QR codes or NFC touch.",
    tags: ["React Native", "TypeScript", "QR Code Engine", "Camera Scanner", "Local Storage", "iOS"],
    color: "#8b5cf6",
    gradient: "linear-gradient(135deg, rgba(139,92,246,0.2) 0%, rgba(109,40,217,0.3) 100%)",
    image: linkMyteImg,
    links: {
      appStore: "https://apps.apple.com/pk/app/linkmyte/id6480371577",
    },
    highlights: [
      "Engineered high-performance QR code generator and camera barcode scanner.",
      "Offline-first architecture enabling access to saved cards without internet.",
      "Customizable themes, social links, and digital card presentation styles.",
    ],
    mockupType: "phone",
    client: "Sohoby IT Solutions",
  },
  {
    id: "bcrypty",
    title: "BCrypty",
    category: "web",
    categoryLabel: "Web3 / Full Stack",
    platform: "Web Application",
    badge: "Open Source / Web3",
    subtitle: "Decentralized Cryptocurrency Transfer & Smart Contract Gateway",
    shortDesc: "A modern Web3 decentralized application allowing users to connect MetaMask and execute secure cryptocurrency transactions worldwide.",
    longDesc: "BCrypty provides an intuitive interface for interacting with the Ethereum blockchain. Users connect their MetaMask wallet, send crypto transactions with automated gas fee estimations, attach custom memo messages, and view a live, immutable feed of verified blockchain transactions.",
    tags: ["React.js", "Web3.js", "MetaMask API", "Solidity", "Hardhat", "Tailwind CSS"],
    color: "#f59e0b",
    gradient: "linear-gradient(135deg, rgba(245,158,11,0.2) 0%, rgba(120,53,15,0.3) 100%)",
    image: bcryptyImg,
    links: {
      github: "https://github.com/SkullCrawler/fyp_project_web3",
    },
    highlights: [
      "Custom Solidity smart contract for structured transaction records and event emission.",
      "Seamless MetaMask wallet connection, state listeners, and network switching.",
      "Rigorous contract unit testing with Hardhat to prevent edge-case gas drain.",
      "Responsive, glassmorphic dark interface with real-time transaction activity feed.",
    ],
    mockupType: "browser",
  },
  {
    id: "react-env-secrets",
    title: "react-env-secrets",
    category: "web",
    categoryLabel: "Open Source NPM Package",
    platform: "TypeScript / Node Library",
    badge: "NPM Package",
    subtitle: "Secure Environment Variable Manager with Full Type Safety & Caching",
    shortDesc: "A custom lightweight NPM package for secure environment variable management in modern JavaScript and TypeScript projects.",
    longDesc: "Developed a specialized developer tooling package to eliminate runtime environment misconfigurations. Provides full TypeScript intellisense for runtime variables, automated schema validation, secure masking of sensitive API tokens, and zero-dependency memory caching for fast lookups.",
    tags: ["JavaScript", "TypeScript", "NPM Package", "Type Safety", "Schema Validation", "Developer Tooling"],
    color: "#10b981",
    gradient: "linear-gradient(135deg, rgba(16,185,129,0.2) 0%, rgba(6,78,59,0.3) 100%)",
    links: {
      github: "https://github.com/SkullCrawler/react-env-secrets",
    },
    highlights: [
      "Strict compile-time and runtime type checking for application environment variables.",
      "Automated secret redaction in logging and error traces.",
      "Zero-overhead in-memory cache reducing process.env lookup penalties.",
      "Full documentation and unit test coverage published on NPM.",
    ],
    mockupType: "code",
  },
  {
    id: "deviddy",
    title: "Deviddy Backend Engine",
    category: "backend",
    categoryLabel: "Backend & Systems",
    platform: "Node.js / Cloud API",
    badge: "Production API",
    subtitle: "Scalable High-Throughput Short-Form Video API Backend",
    shortDesc: "Robust, microservice-ready backend architecture engineered for a short-form video streaming and social media application.",
    longDesc: "Deviddy Backend powers the core engine of a fast-growing short-form content platform. Engineered with high-throughput Express.js services, MongoDB aggregation pipelines, bearer token authentication, automated transactional email delivery via Postmark, and rigorous Postman test suites for CI/CD.",
    tags: ["Node.js", "Express.js", "MongoDB", "Postmark API", "JWT Auth", "Postman", "REST Architecture"],
    color: "#06b6d4",
    gradient: "linear-gradient(135deg, rgba(6,182,212,0.2) 0%, rgba(22,78,99,0.3) 100%)",
    links: {
      github: "https://github.com/SkullCrawler/deviddy_backend",
    },
    highlights: [
      "Designed RESTful endpoint schemas handling concurrent video feeds and user engagement.",
      "Implemented secure JWT bearer token authentication and email verification flows.",
      "Automated endpoint regression tests via Postman collection runners.",
      "Optimized MongoDB indexes and aggregation queries for fast feed generation.",
    ],
    mockupType: "terminal",
  },
  {
    id: "internal-apps",
    title: "Internal Enterprise Suite",
    category: "mobile",
    categoryLabel: "Enterprise Mobile & Web",
    platform: "Internal Company Tools",
    badge: "Enterprise Tooling",
    subtitle: "Internal Productivity & Operational Tools for Sohoby IT Solutions",
    shortDesc: "Suite of internal mobile and web applications designed to streamline team communication, task coordination, and reporting.",
    longDesc: "Developed custom internal tools for Sohoby IT Solutions to automate operational workflows, manage project status updates, and streamline cross-functional developer and manager communication.",
    tags: ["React Native", "React.js", "Role-Based Access", "Internal APIs", "Team Productivity"],
    color: "#AD17A6",
    gradient: "linear-gradient(135deg, rgba(173,23,166,0.2) 0%, rgba(100,10,95,0.4) 100%)",
    image: sohobyInternalImg,
    links: {},
    highlights: [
      "Custom role-based permissions and administrative control panels.",
      "Streamlined reporting workflows reducing internal administrative overhead.",
      "Cross-platform compatibility for iOS, Android, and internal web portals.",
    ],
    mockupType: "phone",
    client: "Sohoby IT Solutions",
  },
];

export const experiences = [
  {
    id: "tuba-role",
    role: "Application Developer",
    company: "Tuba Real Estate - SA",
    period: "February 2026 – Present",
    location: "Saudi Arabia / Remote",
    badge: "Current Role",
    description: "Engineering high-performance cross-platform mobile applications for iOS and Android.",
    bullets: [
      "Engineered high-performance cross-platform mobile applications for iOS and Android, utilizing multi-threaded architectures to improve app performance by 25% and optimize property search workflows.",
      "Architected advanced interactive property map interfaces, localized Arabic RTL search engines, and real-time client inquiry management.",
    ],
    skills: ["React Native", "TypeScript", "Multi-threaded Architecture", "iOS & Android", "Google Maps API", "RTL Localization"],
  },
  {
    id: "sohoby-role",
    role: "React Native Developer",
    company: "Sohoby IT Solutions",
    period: "April 2025 – February 2026",
    location: "Jeddah, Saudi Arabia / Remote",
    badge: "Flagship Mobile Role",
    hasReference: true,
    description: "Developed, optimized, and published multiple flagship mobile applications across iOS App Store and Google Play Store.",
    bullets: [
      "Developed and optimized front-end systems using React Native, enhancing cross-platform compatibility and component-based feature reusability.",
      "Integrated secure payment gateway solutions to ensure reliable transactional flows for users.",
      "Performed technical code reviews and implemented secure authentication protocols to safeguard large-scale application architecture.",
      "Shipped production mobile applications (Tuba, ACC App, Find My Faheem, LinkMyte) and internal enterprise suites.",
    ],
    skills: ["React Native", "TypeScript", "Payment Gateways", "App Store & Play Store", "Redux Toolkit", "Native APIs"],
  },
  {
    id: "eleciam-role",
    role: "Back-end Developer",
    company: "Eleciam LLC",
    period: "February 2024 – September 2024",
    location: "Lahore / Remote",
    badge: "Backend Engineering",
    description: "Architected scalable backend services for high-traffic environments and cross-platform mobile apps.",
    bullets: [
      "Architected scalable backend services for high-traffic environments, achieving a 20% increase in system reliability and ensuring seamless integration with dynamic front-end applications.",
      "Designed and implemented RESTful APIs with version control and rate limiting, reducing API latency by 15% to support cross-platform mobile functionality.",
      "Established modular pipeline structures that accelerated the development lifecycle and improved system scalability.",
    ],
    skills: ["Node.js", "Express.js", "MongoDB", "REST APIs", "Rate Limiting", "Postman", "CI/CD"],
  },
  {
    id: "freelance-web3-role",
    role: "Web3 Developer",
    company: "Freelance",
    period: "January 2023 – March 2025",
    location: "Remote",
    badge: "Decentralized Systems",
    description: "Developed decentralized applications (dApps), smart contracts, and secure blockchain integrations.",
    bullets: [
      "Developed decentralized applications (dApps) and smart contracts, utilizing rigorous testing to ensure DAO stability and comprehensive edge-case coverage.",
      "Integrated blockchain APIs (MetaMask, Alchemy, IPFS), achieving a 50% reduction in operational costs through technical optimization.",
      "Designed tokenomics and engineered secure, decentralized authentication systems while upholding user privacy policies.",
    ],
    skills: ["Solidity", "Hardhat", "Web3.js", "MetaMask", "Alchemy", "IPFS", "React.js"],
  },
  {
    id: "parco-role",
    role: "System Administration Internee",
    company: "PARCO Oil Refinery",
    period: "July 2023 – August 2023",
    location: "Pakistan",
    badge: "Systems & Infrastructure",
    description: "Hands-on experience in enterprise IT network architecture, security, and workstation automation.",
    bullets: [
      "Streamlined OS installation times across 1000+ workstations by implementing automated ISO images, saving 100+ hours.",
      "Researched and drafted recommendations for enterprise Group Policy management across corporate subnetworks.",
    ],
    skills: ["Linux", "Windows Server", "Group Policy", "Network Infrastructure"],
  },
];

export const education = [
  {
    degree: "BS in Computer Science (BS CS)",
    institution: "NFC Institute of Engineering and Technology (NFC IET)",
    location: "Multan, Pakistan",
    period: "September 2020 – August 2024",
    gpa: "GPA: 3.42 / 4.0",
    details: "Core focus on Software Engineering, Mobile Computing, Distributed Systems, Algorithms, and Database Architectures.",
  },
  {
    degree: "Pre-Engineering (Intermediate)",
    institution: "Karam-Dad Qureshi High School",
    location: "Punjab, Pakistan",
    period: "September 2018 – August 2020",
    gpa: "Grade: A+",
    details: "Mathematics, Physics, Chemistry.",
  },
  {
    degree: "Matriculation",
    institution: "PARCO High School",
    location: "Pakistan",
    period: "September 2016 – August 2018",
    gpa: "Grade: A+",
    details: "Science & Computer Studies.",
  },
];

export const certifications = [
  {
    title: "Beyond Commit: Git, GitHub & Copilot Challenge",
    issuer: "Microsoft",
    date: "January 2024",
    badge: "Verified Certification",
  },
];

export const skillCategories = [
  {
    category: "Primary Stack & Mobile Development",
    iconKey: "mobile",
    skills: [
      { name: "React Native", icon: "SiReact", level: "Expert", desc: "Cross-platform iOS & Android engineering" },
      { name: "TypeScript & JavaScript", icon: "SiTypescript", level: "Expert", desc: "Strong typing, modern ES6+, async architectures" },
      { name: "React.js & Next.js", icon: "SiNextdotjs", level: "Expert", desc: "High-performance responsive web applications" },
      { name: "Expo & Native Modules", icon: "SiExpo", level: "Expert", desc: "EAS build, config plugins, custom native bridge" },
      { name: "Store Releases & APIs", icon: "FaApple", level: "Expert", desc: "Apple App Store & Play Store pipelines, Native APIs" },
    ],
  },
  {
    category: "Backend & Systems Architecture",
    iconKey: "server",
    skills: [
      { name: "Node.js & Express.js", icon: "SiNodedotjs", level: "Expert", desc: "Scalable REST APIs, rate limiting, microservices" },
      { name: "MongoDB & PostgreSQL", icon: "SiMongodb", level: "Advanced", desc: "Database modeling, aggregation, indexing, caching" },
      { name: "REST APIs & Pipelines", icon: "FaServer", level: "Expert", desc: "Modular endpoint design, latency reduction" },
      { name: "Auth & Security", icon: "FaShieldAlt", level: "Advanced", desc: "OAuth 2.0 (Google/Apple), JWT, SecureStore" },
      { name: "API Optimization", icon: "FaBolt", level: "Advanced", desc: "In-memory caching, compression, database indexing" },
    ],
  },
  {
    category: "Blockchain & Web3 Ecosystem",
    iconKey: "blockchain",
    skills: [
      { name: "Solidity & Smart Contracts", icon: "SiSolidity", level: "Advanced", desc: "DAO stability, edge-case testing, tokenomics" },
      { name: "Web3.js & MetaMask", icon: "SiWeb3Dotjs", level: "Advanced", desc: "Wallet integration, gas optimization, contract interaction" },
      { name: "Hardhat Testing Framework", icon: "FaCube", level: "Advanced", desc: "Local testnets, deployment scripts, gas profiling" },
      { name: "Alchemy & IPFS Storage", icon: "SiIpfs", level: "Advanced", desc: "RPC nodes, decentralized metadata, transaction caching" },
      { name: "Tokenomics & DeFi Gateways", icon: "FaEthereum", level: "Advanced", desc: "Decentralized auth, token transfers, cost reduction" },
    ],
  },
  {
    category: "Infrastructure, DevOps & Core Languages",
    iconKey: "devops",
    skills: [
      { name: "AWS & Docker", icon: "SiDocker", level: "Advanced", desc: "Cloud infrastructure, containerization, deployments" },
      { name: "Git, GitHub & CI/CD", icon: "SiGithub", level: "Expert", desc: "Branching strategies, automated workflows, EAS" },
      { name: "Postman API Automation", icon: "SiPostman", level: "Expert", desc: "Automated API test suites, collection runners" },
      { name: "Linux & Shell Scripting", icon: "SiLinux", level: "Expert", desc: "Bash automation, environment configuration, server setup" },
      { name: "C++, Java, Python, SQL", icon: "SiPython", level: "Advanced", desc: "Object-oriented programming, data structures, queries" },
    ],
  },
];
